<div class="attendance-item-header">
  <app-list-item-header [item]="item"></app-list-item-header>
</div>

<hr />

<div class="attendance-item-content" (click)="selectItem.emit(item.urlFragment)">
  <div class="item-title" [style.direction]="item.translation.direction">{{ item.title }}</div>

  <div class="item-message">
    <app-hub-item-message [style.direction]="item.translation.direction" [content]="item.message">
    </app-hub-item-message>

    <div class="schoolCallCont">
      <a (click)="$event.stopPropagation()" href="tel:{{ item.schoolTelephone }}" class="schoolCallButton">
        Call School
      </a>
    </div>
  </div>

  @if (item.attachments) {
    <app-attachments
      [attachments]="item.attachments"
      (openAttachment)="openAttachment.emit($event)"
      (getThumb)="getThumb.emit($event)">
    </app-attachments>
  }
</div>

<hr />

<div class="attendance-item-author">
  <app-attendance-publisher
    [item]="item"
    [showPublisherLink]="showPublisherLink"
  (selectAttendanceAlerts)="selectAttendanceAlerts.emit($event)"></app-attendance-publisher>
</div>

<hr />
